module.exports = __webpack_public_path__ + "dde1cb6b018868a94089ca0581019397.svg";